import image from "./images"
const userData = [
    {

        userImg: image.saifali,
        userName: "Saifali",
        usercontact: "3737373737",
        userwhatsapp: "7575757575",
        userEmail: "saifali2021@iic.ac.in",
        userFacebook: "xyz_abc",


    },
    {

        userImg: image.saifali,
        userName: "Saifali",
        usercontact: "3737373737",
        userwhatsapp: "7575757575",
        userEmail: "saifali2021@iic.ac.in",
        userFacebook: "xyz_abc",


    },

];

export default userData;